module.exports = __webpack_public_path__ + "media/images/flags/au-2f2337a481220d675cfa2b6351f76652.svg";